import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetSolicitudPrestacionesEspecialesByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetSolicitudPrestacionesEspecialesByUser = () => {
  const [loadingGetSolicitudPrestacionesEspecialesByUser, setLoadingGetSolicitudPrestacionesEspecialesByUser] = useState(false);
  const [successGetSolicitudPrestacionesEspecialesByUser, setSuccessGetSolicitudPrestacionesEspecialesByUser] = useState(false);
  const [errorGetSolicitudPrestacionesEspecialesByUser, setErrorGetSolicitudPrestacionesEspecialesByUser] = useState<any>(null);
  const [dataGetSolicitudPrestacionesEspecialesByUser, setDataSolicitudPrestacionesEspecialesByUser] = useState<any>(null);

  const [statusGetSolicitudPrestacionesEspecialesByUser, setStatusGetSolicitudPrestacionesEspecialesByUser] =
    useState<StatusGetSolicitudPrestacionesEspecialesByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apirecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // GET
  const getSolicitudPrestacionesEspecialesByUser = async (
    userId: string,
    expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetSolicitudPrestacionesEspecialesByUser(true);
    setSuccessGetSolicitudPrestacionesEspecialesByUser(false);
    setErrorGetSolicitudPrestacionesEspecialesByUser(null);

    try {
      const res = await apirecord.getSolicitudComisionPrestacionesEspecialesByUser(userId, expedienteId);

      setStatusGetSolicitudPrestacionesEspecialesByUser({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetSolicitudPrestacionesEspecialesByUser(true);
      setDataSolicitudPrestacionesEspecialesByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetSolicitudPrestacionesEspecialesByUser({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetSolicitudPrestacionesEspecialesByUser(err);
      console.error("Error en getSolicitudPrestacionesEspecialesByUser:", err);

      throw err;

    } finally {
      setLoadingGetSolicitudPrestacionesEspecialesByUser(false);
    }
  };

  return {
    getSolicitudPrestacionesEspecialesByUser,
    loadingGetSolicitudPrestacionesEspecialesByUser,
    successGetSolicitudPrestacionesEspecialesByUser,
    errorGetSolicitudPrestacionesEspecialesByUser,
    dataGetSolicitudPrestacionesEspecialesByUser,
    statusGetSolicitudPrestacionesEspecialesByUser
  };
};

export default useGetSolicitudPrestacionesEspecialesByUser;
